import {MenuItemRenderer} from '@mintdata-wsp/wsp/ui/components/menus/MenuItemRenderer';
import {RootMenuItemRenderer} from '@mintdata-wsp/wsp/ui/components/menus/RootMenuItemRenderer';
import {SeparatorRenderer} from '@mintdata-wsp/wsp/ui/components/menus/SeparatorRenderer';
import {
    AMenuItemRenderer,
    MenuHandlerFn,
    MenuItemId
} from '@mintdata-wsp/wsp/ui/views/visualDesigner/general/menus/MainMenu';
import {IContextMenuItem} from '@mintdata/mint-kit/impl/components/contextMenu/ContextMenu';
import {ImgIcons} from '@mintdata/mint-kit/impl/properties/components/imgIcon/ImgIcons';
import {IdUtil} from '@mintdata/mint-kit/impl/util/IDUtil';
import {computed, observable} from 'mobx';

export class MenuItem implements IContextMenuItem
{
    @observable
    public isEnabled = true;

    private constructor(public id:MenuItemId,
                        public icon:ImgIcons | null,
                        public title:string,
                        public shortcut:string | null,
                        public renderer:AMenuItemRenderer,
                        public handler:MenuHandlerFn,
                        public subMenus:MenuItem[] | null)
    {
    }

    @computed
    public get label():string
    {
        return this.title;
    }

    @computed
    public get isDisabled():boolean
    {
        return !this.isEnabled;
    }

    @computed
    public get isSeparator():boolean
    {
        return !this.icon && !this.title;
    }

    public static simple(id:MenuItemId, title:string, handler:MenuHandlerFn, subMenus?:MenuItem[]):MenuItem
    {
        const item = MenuItem._toRendererAndSubMenus(subMenus);
        return new MenuItem(id, null, title, null, item.renderer, handler, item.subMenus);
    }

    public static withIcon(id:MenuItemId, title:string, icon:ImgIcons, handler:MenuHandlerFn, subMenus?:MenuItem[]):MenuItem
    {
        const item = MenuItem._toRendererAndSubMenus(subMenus);
        return new MenuItem(id, icon, title, null, item.renderer, handler, item.subMenus);
    }

    public static full(id:MenuItemId,
                       title:string,
                       icon:ImgIcons,
                       shortcut:string,
                       handler:MenuHandlerFn,
                       subMenus?:MenuItem[],
                       renderer?:AMenuItemRenderer):MenuItem
    {
        const item = MenuItem._toRendererAndSubMenus(subMenus);
        return new MenuItem(id, icon, title, null, renderer || item.renderer, handler, item.subMenus);
    }

    public static custom(id:MenuItemId,
                         renderer:MenuItemRenderer,
                         handler:MenuHandlerFn,
                         subMenus?:MenuItem[]):MenuItem
    {
        const item = MenuItem._toRendererAndSubMenus(subMenus);
        return new MenuItem(id, null, null, null, item.renderer, handler, item.subMenus);
    }

    public static separator():MenuItem
    {
        const id = IdUtil.newComponentId();
        const renderer = SeparatorRenderer;

        return new MenuItem(id, null, null, null, renderer, null, null);
    }

    public isEqualTo(other:MenuItem):boolean
    {
        return other && other.id === this.id;
    }

    private static _toRendererAndSubMenus(subMenus:MenuItem[]):{subMenus:MenuItem[], renderer:AMenuItemRenderer}
    {
        let renderer:AMenuItemRenderer;
        if( !subMenus )
        {
            subMenus = null;
            renderer = MenuItemRenderer;
        }
        else
            renderer = RootMenuItemRenderer;

        return {renderer: renderer, subMenus: subMenus};
    }
}
